import Rails from "@rails/ujs"
import initCommunesSelection from './packs/communes_selection';

Rails.start()
initCommunesSelection();
initCommunesSelection('.select-zone-place', '.place-checkbox');
